module.exports = __webpack_public_path__ + "static/media/logo.a478bcb7.png";